import gsap from "gsap";

import Swiper from "swiper";
import { Navigation } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".range-slider");

  sliders.forEach((item) => {
    const main = item.querySelector("[data-swiper]");

    const nextEl = item.querySelector(".swiper-button-next");
    const prevEl = item.querySelector(".swiper-button-prev");

    new Swiper(main, {
      slidesPerView: 1,
      centeredSlides: true,
      initialSlide: 0, //optional
      spaceBetween: 0,
      slideActiveClass: "highlighted",
      // loop: true,
      speed: 800,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
      },
      modules: [Navigation],
    });

    const cards = item.querySelectorAll("[data-3d-card]");

    // cards.forEach((card) => {
    //   const bg = card.querySelector("[data-3d-card-bg]");
    //   const text = card.querySelector("[data-3d-card-text]");

    //   const reductionFactor = 0.1;
    //   const parallaxFactor = 8;
    //   const transitionSpeed = 0.5;
    //   const bgScale = 1.2;

    //   let currentX = 0,
    //     currentY = 0;
    //   let targetX = 0,
    //     targetY = 0;
    //   let animationFrame = null;

    //   card.addEventListener("mousemove", (e) => {
    //     const rect = card.getBoundingClientRect();
    //     const x = e.clientX - rect.left;
    //     const y = e.clientY - rect.top;
    //     const centerX = rect.width / 2;
    //     const centerY = rect.height / 2;

    //     targetX = ((y - centerY) / centerY) * 20 * reductionFactor;
    //     targetY = ((centerX - x) / centerX) * 20 * reductionFactor;

    //     if (!animationFrame) {
    //       animate();
    //     }
    //   });

    //   card.addEventListener("mouseleave", () => {
    //     targetX = 0;
    //     targetY = 0;
    //     card.style.transition = `transform ${transitionSpeed}s ease-out`;
    //     bg.style.transition = `transform ${transitionSpeed}s ease-out`;
    //     text.style.transition = `transform ${transitionSpeed}s ease-out`;

    //     setTimeout(() => {
    //       card.style.transition = "";
    //       bg.style.transition = "";
    //       text.style.transition = "";
    //     }, transitionSpeed * 1000);
    //   });

    //   function animate() {
    //     currentX += (targetX - currentX) * 0.1;
    //     currentY += (targetY - currentY) * 0.1;

    //     card.style.transform = `perspective(1000px) rotateX(${currentX}deg) rotateY(${currentY}deg)`;

    //     if (bg) {
    //       bg.style.transform = `translate3d(${currentY * -parallaxFactor}px, ${
    //         currentX * -parallaxFactor
    //       }px, 0) scale(${bgScale})`;
    //     }

    //     if (text) {
    //       text.style.transform = `translate3d(${currentY * 5}px, ${
    //         currentX * 5
    //       }px, 0)`;
    //     }

    //     if (Math.abs(currentX) > 0.01 || Math.abs(currentY) > 0.01) {
    //       animationFrame = requestAnimationFrame(animate);
    //     } else {
    //       animationFrame = null;
    //     }
    //   }
    // });
  });
});
